import landContract from './land-contract/land-contract.vue';
import woodsContract from './woods-contract/woods-contract.vue';
import waterContract from './water-contract/water-contract.vue';
import sihuangContract from './sihuang-contract/sihuang-contract.vue';
import houseContract from './house-contract/house-contract.vue';
import facilityContract from './facility-contract/facility-contract.vue';
import synthesizeContract from './synthesize-contract/synthesize-contract.vue';
export default {
  components: {
    landContract,
    woodsContract,
    waterContract,
    sihuangContract,
    houseContract,
    facilityContract,
    synthesizeContract
  },
  data() {
    return {
      fromDate: {
        projectType: 1,
        projectSubType: 1,
        userId: '',
        id: '',
        type: ''
      }
    };
  },
  created() {
    this.fromDate.projectType = this.$route.query.projectType;
    this.fromDate.projectSubType = this.$route.query.projectSubType;
    this.fromDate.userId = this.$route.query.userId;
    this.fromDate.id = this.$route.query.id;
    this.fromDate.type = this.$route.query.type;
  },
  computed: {
  },
  mounted() {
  },
  methods: {
  }
};
